"use client";

import { motion } from "framer-motion";
import { fadeUp, stagger } from "@/lib/motion";

const POINTS = [
  {
    n: "1",
    text: "Our inference is state-of-the-art for lightweight open-source models, with higher accuracy and cost efficiency, powered by in-house research.",
  },
  {
    n: "2",
    text: "Integrations are stack-agnostic through one secure, OpenAI-compatible API. Recommendations execute in your gateway and harness of choice.",
  },
  {
    n: "3",
    text: "Cost tracking, spike alerts, error and latency monitoring, eval tooling, local data residency and 24-hour user support.",
  },
];

const MARKERS = [
  "Sovereign infrastructure",
  "Local data residency",
  "OpenAI-compatible",
  "24-hour support",
];

export function ProductionGrade() {
  return (
    <section className="relative">
      <div className="mx-auto max-w-[90rem] px-5 py-16 sm:px-8 sm:py-28">
        <motion.div
          variants={stagger(0.1)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.p variants={fadeUp} className="eyebrow">
            Designed for production-grade workloads
          </motion.p>

          <div className="mt-10 grid gap-4 md:grid-cols-3">
            {POINTS.map((p) => (
              <motion.div
                key={p.n}
                variants={fadeUp}
                tabIndex={0}
                className="rounded-lg p-5 outline-none transition-all duration-300 hover:-translate-y-0.5 hover:bg-card hover:shadow-[0_16px_40px_-24px_rgba(0,0,0,0.3)] hover:ring-1 hover:ring-inset hover:ring-border-strong focus:-translate-y-0.5 focus:bg-card focus:shadow-[0_16px_40px_-24px_rgba(0,0,0,0.3)] focus:ring-1 focus:ring-inset focus:ring-border-strong"
              >
                <p className="font-serif text-lg font-light leading-relaxed text-foreground/90">
                  <span className="font-medium text-foreground">{p.n}.</span>{" "}
                  {p.text}
                </p>
              </motion.div>
            ))}
          </div>

          {/* trust markers: left-aligned, dot-separated, no badges */}
          <motion.div
            variants={fadeUp}
            className="mt-16 flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 sm:justify-start"
          >
            {MARKERS.map((m, i) => (
              <span
                key={m}
                className="flex items-center gap-x-3 font-sans text-sm text-muted"
              >
                {i > 0 && (
                  <span aria-hidden className="text-muted-2">
                    ·
                  </span>
                )}
                <span
                  tabIndex={0}
                  className="group relative cursor-default outline-none transition-colors hover:text-foreground focus:text-foreground"
                >
                  {m}
                  <span className="absolute -bottom-1 left-0 h-px w-0 bg-foreground/35 transition-all duration-300 group-hover:w-full group-focus:w-full" />
                </span>
              </span>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
